import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-392c8187"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-header spa-header" }
const _hoisted_2 = { class: "time-display" }
const _hoisted_3 = { class: "time-label" }
const _hoisted_4 = {
  key: 0,
  id: "header",
  class: "spa-header-second"
}
const _hoisted_5 = { class: "wrap_header" }
const _hoisted_6 = {
  key: 0,
  class: "menubar spa-swipe-container",
  ref: "menuSwipe"
}
const _hoisted_7 = { class: "spa-menu" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus-circle" }, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Thêm ")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-id-card" }, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Khách hàng ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-cart-arrow-down" }, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Mua hàng ")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-bell" }, null, -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Thông báo ")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-file-import" }, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Nhập hàng ")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-dollar" }, null, -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Doanh thu ")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user-plus" }, null, -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Thêm tài khoản ")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-users" }, null, -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Danh sách tài khoản ")
const _hoisted_24 = {
  key: 1,
  class: "menubar spa-swipe-container",
  ref: "menuSwipe"
}
const _hoisted_25 = { class: "spa-menu" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-id-card" }, null, -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Khách hàng ")
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-cart-arrow-down" }, null, -1))
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Mua hàng ")
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-bell" }, null, -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Thông báo ")
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "app-footer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "footer-marquee" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "marquee-text" }, " © 2026 - Phần mềm quản lý Spa — Designed by volequochoang@gmail.com ")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", _hoisted_3, _toDisplayString($setup.formatTimeVN()), 1)
      ]),
      ($props.isLoggedIn)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            label: "Đăng xuất",
            onClick: $setup.logout,
            icon: "pi pi-sign-out",
            iconPos: "right",
            class: "spa-logout-btn"
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    ($props.isLoggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            ($setup.permission)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("ul", _hoisted_7, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/createPage" }, {
                        default: _withCtx(() => [
                          _hoisted_8,
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/customerPage" }, {
                        default: _withCtx(() => [
                          _hoisted_10,
                          _hoisted_11
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/billPage" }, {
                        default: _withCtx(() => [
                          _hoisted_12,
                          _hoisted_13
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, {
                        to: "/notificationPage",
                        class: "spa-menu-item-notify",
                        "data-count": $setup.badgeText
                      }, {
                        default: _withCtx(() => [
                          _hoisted_14,
                          _hoisted_15
                        ]),
                        _: 1
                      }, 8, ["data-count"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/inputPage" }, {
                        default: _withCtx(() => [
                          _hoisted_16,
                          _hoisted_17
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/statisticalPage" }, {
                        default: _withCtx(() => [
                          _hoisted_18,
                          _hoisted_19
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/register" }, {
                        default: _withCtx(() => [
                          _hoisted_20,
                          _hoisted_21
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/userList" }, {
                        default: _withCtx(() => [
                          _hoisted_22,
                          _hoisted_23
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ], 512))
              : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("ul", _hoisted_25, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/customerPage" }, {
                        default: _withCtx(() => [
                          _hoisted_26,
                          _hoisted_27
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/billPage" }, {
                        default: _withCtx(() => [
                          _hoisted_28,
                          _hoisted_29
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, {
                        to: "/notificationPage",
                        class: "spa-menu-item-notify",
                        "data-count": $setup.badgeText
                      }, {
                        default: _withCtx(() => [
                          _hoisted_30,
                          _hoisted_31
                        ]),
                        _: 1
                      }, 8, ["data-count"])
                    ])
                  ])
                ], 512))
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_32
  ], 64))
}